import { startTransition } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

export default function useTransitionalNavigate() {
  const navigation = useNavigate();

  /**
     * Navigates to the path using React's startTransition.
     * This allows the user to continue interacting with the current page while rendering the new page
     * rather than showing a split second "Loading" flash.
     */
  const navigate = (navigateTo: To, navigateOptions?: NavigateOptions) => {
    startTransition(() => {
      navigation(navigateTo, navigateOptions);
    });
  };

  return navigate;
}
